import { ReactNode } from 'react';
import classNames from 'classnames';

import { Classes } from 'types/Classes';
import Typography from '@components/atoms/Typography';
import Collapsible from '@components/Collapsible';
import { FormattedMessage } from 'utils/intl';

import classes from './RestItemsCollapsible.module.scss';
import messages from './RestItemsCollapsible.messages';

type Props = {
  classes?: Classes<'root' | 'trigger' | 'content'>;
  isInitiallyExpanded: boolean;
  itemsCount: number;
  children: ReactNode;
};

const RestItemsCollapsible = ({
  classes: customClasses,
  isInitiallyExpanded,
  itemsCount,
  children,
}: Props): JSX.Element => (
  <Collapsible
    initiallyOpen={isInitiallyExpanded}
    className={classNames(classes.expand, customClasses?.root)}
    trigger={(isOpened, handleClick) => (
      <Typography variant="body2" weight="700" renderAs="div" className={customClasses?.trigger} onClick={handleClick}>
        <FormattedMessage {...(isOpened ? messages.showLess : messages.showMore)} />
        {!isOpened && <span className={classes.extendHandlerCounter}>{`(${itemsCount})`}</span>}
      </Typography>
    )}
    unmountOnClose
  >
    <div className={classNames(classes.wrapper, classes.expandedNodes, customClasses?.content)}>{children}</div>
  </Collapsible>
);

export default RestItemsCollapsible;
